import { render, staticRenderFns } from "./2_DateQuestion.vue?vue&type=template&id=263878e8&scoped=true&"
import script from "./2_DateQuestion.vue?vue&type=script&lang=js&"
export * from "./2_DateQuestion.vue?vue&type=script&lang=js&"
import style0 from "./2_DateQuestion.vue?vue&type=style&index=0&id=263878e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263878e8",
  null
  
)

export default component.exports